// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U4KpIpoiBao1F55qjHF5{width:100%}.WNhNydawJwcvNPH7RLyi{margin-top:40px;margin-bottom:24px;display:inline-block}.LoYSfhxCyi8IDDa7gUxL{gap:12px;display:flex}.fkhxarfqTUEZPWJMJwO8{align-items:flex-start;margin-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `U4KpIpoiBao1F55qjHF5`,
	"sectionTitle": `WNhNydawJwcvNPH7RLyi`,
	"nameRow": `LoYSfhxCyi8IDDa7gUxL`,
	"consent": `fkhxarfqTUEZPWJMJwO8`
};
export default ___CSS_LOADER_EXPORT___;
